import { createSlotsContext } from "@grandvisionhq/slots";
const [CartSidebarSlotsProvider, useCartSidebarSlots] = createSlotsContext({
  displayName: "CartSidebarSlotsContext"
});
export {
  CartSidebarSlotsProvider,
  useCartSidebarSlots
};
//# sourceMappingURL=context.js.map
